import { useIdleTimer } from 'react-idle-timer';

const TIMEOUT = 1000 * 60 * 60 * 3; // 3 hours

const IdleReload: React.FC = () => {
  const handleOnActive = () => window.location.reload();

  useIdleTimer({
    timeout: TIMEOUT,
    onActive: handleOnActive,
  });

  return null;
};

export default IdleReload;
